import { render, staticRenderFns } from "./errorDisplay.vue?vue&type=template&id=1f420ca4&"
import script from "./errorDisplay.vue?vue&type=script&lang=js&"
export * from "./errorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports